(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["fe-ui-kiosk"] = factory();
	else
		root["fe-ui-kiosk"] = factory();
})(globalThis, () => {
return 